import { AuthService } from 'shared/lib/keycloak';

export const getUserName = () => {
  const userProfile = AuthService.getUserProfile();

  const teacherNickName = userProfile.attributes?.nickName?.[0];
  const teacherLastName = userProfile.lastName;

  return teacherNickName ?? `Educator ${teacherLastName}`;
};
